<template>
  <transition name='slide-fade'>
    <div class='page-component-up' v-if='isShow' @click='getTop'>
      <img src="../assets/images/images/top.png" alt="">
    </div>
  </transition>
</template>
<script>
export default {
  name: 'BackTop',
  data () {
    return {
      isShow: false,
      timer: ''
    }
  },
  methods: {
   
    showIcon () {
      clearTimeout(this.timer);
      this.timer = setTimeout(()=> {
        let height = document.documentElement.scrollTop || document.body.scrollTop;
      
        if (height > 200) {
          this.isShow = true
        } else if (height < 200) {
          this.isShow = false
        }
      },300)
      
    },
    getTop () {
      let timer = setInterval(() => {
        let top = document.documentElement.scrollTop || document.body.scrollTop;
        let speed = Math.ceil(top / 5)
        document.documentElement.scrollTop = top - speed
        document.body.scrollTop = top - speed
        if (top === 0) {
          clearInterval(timer)
        }
      }, 20)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.showIcon)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.showIcon)
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all .1s ease;
}
.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.3, 0.8, 1.0);
  opacity: 0;
}
.slide-fade-enter, .slide-fade-leave-to {
 transform: translateX(140px);
  opacity: 0;
}
.page-component-up {
  background: #892885;
  position: fixed;
  right: 1rem;
  bottom: 6rem;
  width: 40px;
  height: 40px;
  border-radius: 25px;
  cursor: pointer;
  opacity: .5;
  transition: .3s;
  text-align: center;
  z-index: 999;
}
.el-icon-caret-top {
  font-size: 36px;
  margin-top: 7px;
  color: #FFFFFF;
  text-align: center;
  z-index: 1000
}
.hover {
  background-color: #409EFF;
}
</style>